<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="_idContainer003" role="doc-chapter">
<p class="pl-title"><a id="_idTextAnchor001"></a>Seeking the Truth</p>
<p class="pl-author">Terri Reed</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Seeking_the_Truth.vue?4383e060